import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUserPreferencesEditionRequestFailure() {
      return getState().isFailure;
    },
    isUserPreferencesEditionRequestPending() {
      return getState().isPending;
    },
    isUserPreferencesEditionRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
